import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-flexbox-grid';

import Cover from './styled-components';

const FullBackgroundImage = ({ children }) => (
  <Cover>
    <Col xs={12}>{children}</Col>
  </Cover>
);

FullBackgroundImage.propTypes = {
  children: PropTypes.element.isRequired
};

export default FullBackgroundImage;



// WEBPACK FOOTER //
// ./src/views/officials-connect/layouts/FullBackgroundImage/index.jsx